import { useState, useEffect, useRef, useCallback } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Autocomplete, Button, Card, CardActions, CardContent, TextField, Typography, Paper, IconButton } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { SearchOutlined } from '@mui/icons-material';
import { makeStyles } from "@material-ui/core/styles";
import { authAPI } from "../services/AuthAPI";

const User_Detail = ({ isMobile, closeNav }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { isLogin } = useSelector(state => state.user)
    const [username, setUsername] = useState("")
    const [select, setSelect] = useState("")
    const userRef = useRef("")
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [prefix, setPrefix] = useState([])
    const useStyles = makeStyles(theme => ({
        root: {
            padding: theme.spacing(4, 3)
        },
    }));

    useEffect(() => {
        if (isLogin) {
            dispatch({ type: "PREFIX_FETCH_START" })
            authAPI.getPrefixAdmin()
                .then((res) => {
                    if (res.status == 200 && Array.isArray(res.message)) {
                        setPrefix(res.message)
                    }
                    setTimeout(() => {
                        dispatch({ type: "PREFIX_FETCH_END" })
                    }, 500);
                })
                .catch((err) => {
                    setTimeout(() => {
                        dispatch({ type: "PREFIX_FETCH_END" })
                    }, 500);
                })
        }
    }, [isLogin])

    const handleSearchUser = useCallback(async () => {
        try {
            setLoading(true)
            const { status, message } = await authAPI.userDetail((select || "") + username)
            setLoading(false)
            if (status == 404) {
                setUsername("")
                throw { message }
            } else if (status != 200) throw { message }
            else {
                userRef.current = (select || "") + username
                setData(message)
                return;
            }
        } catch (error) {
            setLoading(false)
        }
    }, [username, select])

    const keyPress = useCallback(async (e) => {
        try {
            if (e.keyCode == 13 && !loading && userRef.current != (select || "") + username && username && username != "") {
                setLoading(true)
                const { status, message } = await authAPI.userDetail((select || "") + username)
                setLoading(false)
                if (status == 404) {
                    setUsername("")
                    throw { message }
                } else if (status != 200) throw { message }
                else {
                    userRef.current = (select || "") + username
                    setData(message)
                }
            }
        } catch (error) {
            setLoading(false)
        }
    }, [username, select])

    const companyFind = useCallback((text) => {
        let newText = text.replace(/\d/g, "")
        let find = prefix.find((res) => res.prefix == (newText == "" ? null : newText))
        return find ? find.name_th : "หาไม่เจอ"
    }, [prefix])

    const classes = useStyles();

    return (
        <>
            <div className='container h-100vh' style={{ marginTop: '10%', display: closeNav ? 'flex' : isMobile ? 'none' : 'flex', marginTop: !isMobile ? 0 : '70px', justifyContent: 'flex-start', padding: '0' }}>
                <Paper className={`${classes.root} paper-root`} style={{ boxShadow: 'none', width: '85%', padding: '3%' }}>
                    <Typography variant="h3" component="div">
                        ค้นหา User จากรหัสพนักงาน
                    </Typography>
                    <div className={`${classes.enter} enter-text`} style={{ paddingTop: '4%' }}>
                        <Autocomplete
                            options={prefix}
                            onChange={(event, newValue) => {
                                setSelect(newValue?.prefix)
                            }}
                            renderOption={(props, option) => {
                                return (
                                    <li {...props} key={option._id}>
                                        {option.org_name}
                                    </li>
                                );
                            }}
                            getOptionLabel={(option) => option.org_name || ""}
                            isOptionEqualToValue={(option) => option.prefix == prefix}
                            renderInput={(params) => (
                                <TextField {...params} fullWidth label="หน่วยงาน" className={`${classes.textField} textField`} />
                            )} />
                    </div>
                    <div className={`${classes.enter} enter-text`} style={{ paddingTop: '4%' }}>
                        <TextField
                            fullWidth
                            label="กรอกรหัสพนักงาน"
                            className={`${classes.textField} textField`}
                            helperText="รหัสพนักงาน"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            onKeyDown={keyPress}
                            InputProps={{
                                endAdornment: <IconButton
                                    disabled={loading || userRef.current == (select || "") + username || !username || username == ""}
                                    aria-label="search username"
                                    onClick={handleSearchUser}
                                >
                                    <SearchOutlined />
                                </IconButton>,
                            }}
                        />
                    </div>
                    {data && <Card sx={{ minWidth: 275, mt: 2.5, borderRadius: 5, padding: 2.5 }}>
                        <CardContent>
                            <Typography variant="h5" component="div" sx={{ mb: 1 }}>
                                ชื่อ : {data?.fullname}
                            </Typography>
                            <Typography variant="h5" component="div" sx={{ mb: 1 }}>
                                Email : {data?.email || "-"}
                            </Typography>
                            <Typography sx={{ mb: 1 }}>
                                Position : {data?.PositionName}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 1 }}>
                                บริษัท : {companyFind(userRef.current)}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 1 }}>
                                สถานะ : {data?.status ? "ใช้งานได้" : "ใช้งานไม่ได้"}
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button sx={{ color: "rgb(106, 178, 58)" }} onClick={() => navigate(`/manage-pdpa/view-pdpa/${data?._id}`)} size="small" disabled={!data?.pdpa}>{data?.pdpa ? "ทำ PDPA แล้ว" : "ยังไม่ได้ทำ PDPA"}</Button>
                        </CardActions>
                    </Card>}
                </Paper>
            </div>
        </>
    )
}

export default User_Detail